var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 75,
    viewBox: "0 0 60 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8254 30.3494L0 74.0074L40.0048 33.9954L21.8254 30.3494Z",
    fill: "#2D66AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8254 30.3494L0 74.0074L32.4895 32.4895L21.8254 30.3494Z",
    fill: "#3D79BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00701904 25.9758L40.0046 33.9955L59.9998 14.0003L0.00701904 25.9758Z",
    fill: "#DB2328"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0144043 25.9614L36.3084 27.6042L60 14.0003L0.0144043 25.9614Z",
    fill: "#EF434D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7838 3.70823e-06C35.3983 -0.00142172 34.0435 0.408127 32.8908 1.17684C31.7381 1.94555 30.8393 3.03888 30.3081 4.31852C29.7769 5.59816 29.6372 7.0066 29.9066 8.36566C30.176 9.72472 30.8425 10.9733 31.8217 11.9535C32.8009 12.9338 34.0488 13.6015 35.4076 13.8723C36.7664 14.1432 38.175 14.0049 39.4552 13.475C40.7353 12.9451 41.8296 12.0474 42.5995 10.8955C43.3694 9.74362 43.7803 8.38924 43.7803 7.00372C43.7803 5.14747 43.0434 3.36714 41.7315 2.05389C40.4196 0.740646 38.6401 0.00191344 36.7838 3.70823e-06Z",
    fill: "#EF434D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3872 4.8132C31.3762 3.79123 31.5928 2.77963 32.0213 1.85175C31.2716 2.55563 30.6862 3.41612 30.307 4.37198C29.9277 5.32783 29.7638 6.35554 29.8269 7.38195C29.89 8.40836 30.1787 9.40824 30.6722 10.3104C31.1658 11.2126 31.8521 11.9949 32.6825 12.6016C33.5128 13.2083 34.4666 13.6245 35.4761 13.8206C36.4856 14.0167 37.5259 13.9878 38.5229 13.7361C39.52 13.4843 40.4493 13.0159 41.2447 12.3641C42.0401 11.7124 42.6821 10.8932 43.1249 9.96511C42.1236 10.8835 40.8769 11.4907 39.5365 11.713C38.1962 11.9352 36.8201 11.7628 35.576 11.2168C34.332 10.6707 33.2736 9.77458 32.5298 8.63759C31.786 7.50061 31.389 6.17184 31.3872 4.8132Z",
    fill: "#DB2328"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsLogo);
export default __webpack_public_path__ + "static/media/KS_logo.f18e30324999ae7819d91886a702e606.svg";
export { ForwardRef as ReactComponent };